import { z } from "zod";

const translationPath = "page.4uHcp.hcp.fundraising.errors.";

const healthProgramSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.number().optional(),
  },
  { invalid_type_error: translationPath + "health_program_type" }
);

const individualSchema = z.object({
  id: z.string(),
  individualName: z.string(),
  code: z.number().optional(),
});

const healthProgramCaptationStatusSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional(),
  },
  { invalid_type_error: translationPath + "captation_status" }
);

export const captationSchema = z
  .object({
    id: z.string().optional(),
    healthProgram: healthProgramSchema,
    individual: individualSchema.nullish(),
    healthProgramCaptationStatus: healthProgramCaptationStatusSchema,
  })
  .superRefine((val, ctx) => {
    if (!val.id && !val.individual) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["individual"],
        message: translationPath + "individual",
      });
    }
  });

export type TCaptationForm = z.infer<typeof captationSchema>;
